import { Check, X } from "lucide-react";
import { beforeAfter } from "../../lib/mockData";

export const BeforeAfter = ({ demoId }) => {
  const data = beforeAfter[demoId];
  if (!data) return null;
  return (
    <section className="mt-16" data-testid={`before-after-${demoId}`}>
      <div className="text-center mb-10">
        <p className="text-sm font-semibold uppercase tracking-widest text-primary">
          The transformation
        </p>
        <h2 className="font-display text-3xl sm:text-4xl mt-2">
          Before vs After StaffLink Automation
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="glass rounded-2xl p-8 border-l-4 border-l-destructive/70">
          <div className="flex items-center gap-2 mb-4">
            <X className="w-5 h-5 text-destructive" />
            <h3 className="font-display text-xl">Without automation</h3>
          </div>
          <ul className="space-y-3">
            {data.before.map((item, i) => (
              <li key={i} className="flex gap-3 text-muted-foreground">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-destructive/70 shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="glass rounded-2xl p-8 border-l-4 border-l-accent">
          <div className="flex items-center gap-2 mb-4">
            <Check className="w-5 h-5 text-accent" />
            <h3 className="font-display text-xl">With StaffLink automation</h3>
          </div>
          <ul className="space-y-3">
            {data.after.map((item, i) => (
              <li key={i} className="flex gap-3">
                <Check className="w-4 h-4 text-accent mt-1 shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
